var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-list"},[_vm._m(0),_c('div',{staticClass:"product-list-body"},_vm._l((_vm.items),function(item,index){return _c('store-product-body',{key:index,attrs:{"item":item,"index":index}})}),1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-list-header"},[_c('span',{staticClass:"header-title"},[_vm._v("店铺推荐")])])
}]

export { render, staticRenderFns }